import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useUser } from './UserContext'; // Import the useUser hook

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const { user } = useUser(); // Get the user from the UserContext

  useEffect(() => {
    // Only fetch companies if the user is logged in
    if (user) {
      axios.get('/api/empresas')
        .then(response => {
          setCompanies(response.data);
          // Default to selecting all companies
          if (response.data.length > 0) {
            setSelectedCompanyIds(response.data.map(c => c.id));
          }
        })
        .catch(error => {
          console.error("Error fetching companies:", error);
        });
    } else {
      // If user logs out, clear the company data
      setCompanies([]);
      setSelectedCompanyIds([]);
    }
  }, [user]); // This effect now depends on the user object

  const value = {
    companies,
    selectedCompanyIds,
    setSelectedCompanyIds,
    isAllCompaniesSelected: selectedCompanyIds.length === 0 || selectedCompanyIds.length === companies.length,
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};
